class YotpoReviewsStars extends HTMLElement {
  connectedCallback() {
    if (yotpoWidgetsContainer && yotpoWidgetsContainer.initWidget) {
      const instanceEl = this.querySelector('.yotpo-widget-instance')

      if (!instanceEl) return

      const instanceId = instanceEl.getAttribute('data-yotpo-instance-id')

      if (!instanceId) return

      yotpoWidgetsContainer.initWidget(instanceId, instanceEl)
    }
  }
}

customElements.define('yotpo-reviews-stars', YotpoReviewsStars)
